import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ShowDialogParams } from '@/store/dialog/types';
import { AddContactListStart } from '@/store/formCreator/actions';
import { UpdateDialog } from '@/store/dialog/actions';
import { CreateNewListModal } from '../../components/CreateNewListModal';

interface CreateListModalProps {
    popBackCallback: () => void;
}

export const useCreateListModalParams = ({ popBackCallback }: CreateListModalProps): {
    getCreateListModalProps: () => ShowDialogParams;
} => {
    const dispatch = useDispatch<any>();
    const { t } = useTranslation();
    const listName = useRef<string>();
    const enableSubscribeManagement = useRef<boolean>();
    
    const onClose = (): void => {
        popBackCallback();
    };

    const getCreateListModalProps = (): ShowDialogParams => {
        const onSaveClick = (): void => {
            if (!listName.current) {
                return;
            }

            const listData = {
                ListName: listName.current,
                Rule: `List = '${listName.current}'`,
                AllowUnsubscribe: enableSubscribeManagement.current
            };

            dispatch(AddContactListStart(listData)) 
        };

        const onChangeListName = (newListName: string): void => {
            listName.current = newListName
            !!newListName && dispatch(UpdateDialog({ isDisabled: false }))
        };

        const onChangeSubManagement = (enableSubMmagements: boolean): void => {
            enableSubscribeManagement.current = enableSubMmagements;
        }

        const body = (
            <CreateNewListModal onChangeListName={onChangeListName} onChangeSubManagement={onChangeSubManagement} />
        );

        return {
            title: t('createnewlist'),
            confirmLabel: t('save'),
            onClickConfirm: onSaveClick,
            cancelLabel: t('cancel'),
            onClickCancel: onClose,
            isDisabled: true,
            body,
            id: 'create-list-modal',
            width: '600px',
            isHiddenManually: true,
        };
    };
    return { getCreateListModalProps };
};
